import { useMemo } from "react";

import { Destination, FormField } from "@prequel/react";
import { Dropdown } from "@prequel/shared-components";

import VendorLogo from "@/containers/VendorLogo";

type SelectWrapperProps = {
  field: FormField & { form_element: "select" };
  destination: Destination;
  setDestinationField: (
    key: keyof Destination | "primary_public_key" | "secondary_public_key",
    value: string | boolean | string[],
  ) => void;
  disabled: boolean;
};

const SelectWrapper = ({ field, destination, setDestinationField, disabled }: SelectWrapperProps) => {
  const items = useMemo(
    () =>
      field.enum?.map((e) => ({
        key: e.key.toString(),
        text: e.display,
        icon: () => <VendorLogo logo_url={e.icon_url ?? ""} />,
      })),
    [field.enum],
  );

  const fieldName = field.name;
  const destinationValue = destination[fieldName];
  const selected = useMemo(() => items?.find(({ key }) => key === destinationValue), [items, destinationValue]);

  return (
    <Dropdown
      label={field.label}
      items={items ?? []}
      selectedItem={selected}
      setSelectedItem={(item) => setDestinationField(field.name, item.key)}
      disabled={disabled || items?.length === 0}
    />
  );
};

export default SelectWrapper;
